module.exports = __webpack_public_path__ + "static/media/placeholder_150x150.be5479d5.svg";